import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  EN: {
    // Navigation
    nav: {
      home: 'home',
      about: 'about',
      work: 'work',
      contact: 'contact'
    },
    
    // Home
    home: {
      greeting: 'Hello, I\'m',
      name: 'Alvin Ahmad',
      role: 'Software Engineer',
      tagline: 'Crafting Digital Excellence',
      subtitle: 'Building high-impact mobile apps & web platforms that empower users and businesses globally.',
      viewWork: 'VIEW MY WORK',
      contactMe: 'CONTACT ME',
      discoverMore: 'DISCOVER MORE ABOUT ME',
      whatWeShip: 'What we ship',
      whatWeShipSubtitle: 'From concept to launch, we build products that matter.',
      seeCaseStudies: 'SEE OUR CASE STUDIES',
      smallTeam: 'Small team,',
      bigResults: 'big results',
      knowMore: 'KNOW MORE ABOUT US',
      hireSoon: 'AVAILABLE FOR PROJECTS',
      availableForWork: 'Available For Work',
      satisfaction: 'Satisfaction',
      happyCustomers: 'Happy Customers',
      years: 'Years',
      experience: 'Experience',
      experienceDesc: 'In Real Project Studies, and Freelance',
      featuredWork: 'Featured work',
      featuredWorkDesc: 'We create innovative and purposeful designs that not only capture attention but also drive meaningful results.',
    },

    // About
    about: {
      title: 'Result-Driven Design',
      subtitle: 'Focused on mobile applications and web platforms, I bring innovation, performance, and user-centric design to every project.',
      partOf: 'Part of',
      digitalEcosystem: 'Digital Ecosystem',
      description: 'Alvin Ahmad is dedicated to building high-impact digital solutions that empower users and businesses across the globe.',
      description2: 'Focused on mobile applications and web platforms, I bring innovation, performance, and user-centric design to every project.',
      viewMyWork: 'VIEW MY WORK',
      technologies: 'Technologies',
      cleanCode: 'Clean code is my passion',
      yearsExp: 'Years Experience',
      projectsDone: 'Projects Done',
      clientsSatisfied: 'Clients Satisfied',
      contactMe: 'CONTACT ME',
      resultDriven: 'Result driven',
      designDriver: 'Design is a powerful driver of marketing performance. Some rush in with a clunky landing page, others obsess over details for weeks. We strike the balance crafting a design culture that\'s sharp, efficient, and built to perform.',
      effectiveDesign: 'Effective design solves real problems whether it\'s enhancing perceived value, boosting conversions, clarifying a brand message, or adapting to a new market. To achieve this, businesses need seasoned designers who grasp both their vision and the evolving landscape they operate in.',
      mission: 'is a software developer with a clear mission: to build digital products that combine clean code, performance, and exceptional user experience. Too often, applications sacrifice usability for features or vice versa.',
      handlingApps: 'handling production web apps',
      raisedRevenue: 'Raised revenue by the projects',
      usersGrowth: 'users growth',
      satisfyingFeedback: 'satisfying feedback',
      techIWorkWith: 'TECHNOLOGIES I WORK WITH',
      cleanCodePassion: 'Clean code is my passion',
      passionateDev: 'I am a passionate software developer focused on building high-quality mobile and web applications. With expertise in React, React Native, and modern web technologies, I deliver solutions that are both performant and user-friendly.',
      getInTouch: 'GET IN TOUCH',
      freelance: 'Available for freelance projects and collaborations. Let\'s build something great together.',
      dedicated: 'Alvin Ahmad is dedicated to building high-impact digital solutions that empower users and businesses across the globe.',
      focused: 'Focused on mobile applications and web platforms, I bring innovation, performance, and user-centric design to every project.',
    },

    // Work
    work: {
      title: 'Selected Works',
      subtitle: 'A collection of projects I\'ve worked on',
      loading: 'Loading projects...',
      error: 'Failed to load projects',
      retry: 'Try Again',
      gridView: 'Grid View',
      listView: 'List View',
      viewProject: 'View Project',
      viewDemo: 'View Demo',
      viewCode: 'View Code',
    },

    // Project
    project: {
      notFound: 'Project not found',
      backToWork: 'Back to Work',
      back: 'Back',
    },

    // Contact
    contact: {
      title: 'Let\'s Work Together',
      subtitle: 'Have a project in mind? Let\'s discuss how I can help bring your ideas to life.',
      name: 'Your Name',
      email: 'Your Email',
      phone: 'Phone Number',
      company: 'Company',
      website: 'Website (optional)',
      sendMessage: 'Send Message',
      sending: 'Sending...',
      successMessage: 'Message sent successfully!',
      errorMessage: 'Failed to send message. Please try again.',
      faqTitle: 'Frequently Asked Questions',
      testimonialsTitle: 'What clients say',
      bookCall: 'BOOK A CALL',
      bookDiscoveryCall: 'Book a Free Consultation',
      formTitle: 'Let\'s Discuss Your Next Project',
      availableSlots: 'Time Slots Available Now',
      contactSales: 'CONTACT SALES',
      nameLabel: 'Full name',
      emailLabel: 'Email *',
      phoneLabel: 'Phone number *',
      companyLabel: 'Company *',
      websiteLabel: 'Website *',
      loginPricing: 'Login and pricing & brief',
      trustedBy: 'TRUSTED BY CLIENTS WORLDWIDE',
      heading: 'Let\'s build your next digital product',
      headingDesc: 'I\'m a software developer specializing in mobile and web applications. From concept to deployment, I craft solutions that are fast, scalable, and beautiful.',
      startups: 'Startups',
      smes: 'SMEs',
      enterprises: 'Enterprises',
      agencies: 'Agencies',
      availableForProjects: 'Available for new projects',
      trustedByClients: 'Trusted by',
      satisfiedClients: 'satisfied clients',
      fullName: 'Full name',
      emailRequired: 'Email *',
      phoneRequired: 'Phone number *',
      companyRequired: 'Company *',
      websiteRequired: 'Website *',
      successMsg: 'Message sent successfully! I\'ll get back to you soon.',
      errorMsg: 'Failed to send message. Please try again or email me directly.',
      faq1Question: 'What types of projects do you take on?',
      faq1Answer: 'I specialize in mobile app development (React Native) and web applications (React/Next.js), from MVPs to full-scale production apps.',
      faq2Question: 'What\'s your typical project timeline?',
      faq2Answer: 'It depends on complexity. A landing page takes 3-5 days, a company profile 7-14 days, and a full web/mobile app 20-30 days.',
      faq3Question: 'Do you work with international clients?',
      faq3Answer: 'Absolutely! I work with clients worldwide. I\'m flexible with time zones and communicate primarily in English and Indonesian.',
      faq4Question: 'What technologies do you use?',
      faq4Answer: 'I primarily use React/Next.js for frontend, Node.js/Supabase for backend, and React Native for mobile apps. I\'m flexible based on project needs.',
      faq5Question: 'Do you provide ongoing support after launch?',
      faq5Answer: 'Yes, I offer maintenance packages and can provide ongoing support for bug fixes, updates, and new features.',
    },

    // Profile
    profile: {
      hireMe: 'Hire Me',
      resumeDesc: 'Preview my resume online or download a copy for your reference.',
      getResume: 'Get Resume',
      previewResume: 'Preview Resume',
    },

    // Seller
    seller: {
      welcome: 'Welcome to',
      galaxyStore: 'Galaxy Store',
      developer: 'Developer Portal',
      subtitle: 'Premium Android applications for Samsung Galaxy devices',
      visitStore: 'Visit Galaxy Store',
      documentation: 'Documentation',
      statsTitle: 'App Statistics',
      statsSubtitle: 'Track performance across all published applications',
      totalApps: 'Total Published Apps',
      avgRating: 'Average Rating',
      totalDownloads: 'Total Downloads',
      policiesTitle: 'Developer Policies',
      policiesSubtitle: 'Guidelines and policies for app submissions',
      termsOfService: 'Terms of Service',
      tosDesc: 'Rules and guidelines for using our developer platform',
      readTerms: 'Read Terms',
      privacyPolicy: 'Privacy Policy',
      privacyDesc: 'How we collect, use, and protect your data',
      viewPolicy: 'View Policy',
      contactTitle: 'Contact & Support',
      contactSubtitle: 'Get in touch with our developer support team',
      email: 'Email',
      sendEmail: 'Send Email',
      whatsapp: 'WhatsApp',
      message: 'Message',
      responseTime: 'Response within 24 hours',
      freeConsultation: 'Free initial consultation',
    },

    // Seller Help
    sellerHelp: {
      title: 'How Can I Help You?',
      subtitle: 'Find answers about my app development services, get project quotes, and learn about my development process',
      searchPlaceholder: 'Search for answers...',
      popular: 'Popular',
      browseByCategory: 'Browse by Category',
      categorySubtitle: 'Choose a topic to find relevant answers quickly',
      allTopics: 'All Topics',
      appDevelopment: 'App Development',
      businessPayment: 'Business & Payment',
      supportMaintenance: 'Support & Maintenance',
      allQuestions: 'All Questions',
      resultsFound: 'results found',
      helpful: 'Helpful',
      needMoreHelp: 'Need More Help?',
      stillNeedHelp: 'Still Need Help?',
      supportSubtitle: 'Let\'s discuss your project and how I can help bring your ideas to life',
      directContact: 'Direct Contact',
      contactDesc: 'Get personalized consultation for your project',
      projectConsultation: 'Project Consultation',
      consultationDesc: 'Send a message to discuss your requirements',
      sendEmail: 'Send Email',
      message: 'Message',
      rateExperience: 'How Was Your Experience with My Services?',
      feedbackSubtitle: 'Your feedback helps me improve the quality of my services',
      noResults: 'No Results Found',
      noResultsDesc: 'Try adjusting your search terms or browse different categories',
      resetFilters: 'Reset Filters',
      startProject: 'Start a Project',
      startProjectDesc: 'Get a quote for your custom app development',
      viewPortfolio: 'View Portfolio',
      viewPortfolioDesc: 'Check out my previous work and projects',
      technicalDocs: 'Technical Documentation',
      technicalDocsDesc: 'Access development guides and resources',
      devSupport: 'Developer Support',
      thankFeedback: 'Thank you for your feedback',
      thankRating: 'Thank you for rating',
      stars: 'stars',
      results: 'results',
      result: 'result',
      found: 'found',
      responseWithin24: 'Response within 24 hours',
      freeConsultation: 'Free Initial Consultation',
    },

    // Pricing
    pricing: {
      eyebrow: 'Pricing',
      title: 'Simple, transparent pricing for real results.',
      subtitle: 'Pick a package and choose how you pay — in full, 50% down, or per milestone. Every project runs through your own dashboard with invoices, an AI project manager, and final deliverables.',
      payInFull: 'Pay in Full',
      payInFullDesc: 'One payment, settle the whole project upfront.',
      dp50: 'Down Payment 50%',
      dp50Desc: 'Pay half to start, the rest on delivery.',
      milestone: 'Per Milestone',
      milestoneDesc: 'Split into milestones from your brief; pay as we go.',
      all: 'All',
      mostPopular: 'Most Popular',
      startProject: 'Start Project',
      contactUs: 'Contact Us',
      perProject: '/ project',
      custom: 'Custom',
      noPackages: 'No Packages Yet',
      noPackagesDesc: 'Add service packages in the admin dashboard to show them here.',
      startYourProject: 'Start Your Project',
      projectTotal: 'Project Total',
      chooseHowToPay: 'Choose How You Pay',
      setFromBrief: 'Set from Brief',
      settingUp: 'Setting up...',
      continueToDashboard: 'Continue to Dashboard',
      signInWithGoogle: 'Sign in with Google',
      nextStep: 'Next: tell us about your project, then pay securely via Doku. You can track everything in your dashboard.',
      nowThen: 'now, then',
    },

    // Common
    common: {
      loading: 'Loading...',
      error: 'Error',
      retry: 'Retry',
      back: 'Back',
      close: 'Close',
      save: 'Save',
      cancel: 'Cancel',
      confirm: 'Confirm',
      delete: 'Delete',
      edit: 'Edit',
      add: 'Add',
      search: 'Search',
      filter: 'Filter',
      sort: 'Sort',
      next: 'Next',
      previous: 'Previous',
      pageNotFound: 'Page not found',
      backToHome: 'Back to Home',
    }
  },

  ID: {
    // Navigation
    nav: {
      home: 'beranda',
      about: 'tentang',
      work: 'karya',
      contact: 'kontak'
    },
    
    // Home
    home: {
      greeting: 'Halo, saya',
      name: 'Alvin Ahmad',
      role: 'Software Engineer',
      tagline: 'Menciptakan Keunggulan Digital',
      subtitle: 'Membangun aplikasi mobile & web platform berdampak tinggi yang memberdayakan pengguna dan bisnis secara global.',
      viewWork: 'LIHAT KARYA SAYA',
      contactMe: 'HUBUNGI SAYA',
      discoverMore: 'TEMUKAN LEBIH BANYAK TENTANG SAYA',
      whatWeShip: 'Apa yang kami buat',
      whatWeShipSubtitle: 'Dari konsep hingga peluncuran, kami membangun produk yang bermakna.',
      seeCaseStudies: 'LIHAT STUDI KASUS KAMI',
      smallTeam: 'Tim kecil,',
      bigResults: 'hasil besar',
      knowMore: 'TAHUBAN LEBIH BANYAK TENTANG KAMI',
      hireSoon: 'TERSEDIA UNTUK PROYEK',
      availableForWork: 'Tersedia Untuk Bekerja',
      satisfaction: 'Kepuasan',
      happyCustomers: 'Pelanggan Puas',
      years: 'Tahun',
      experience: 'Pengalaman',
      experienceDesc: 'Dalam Studi Proyek Nyata, dan Pekerjaan Lepas',
      featuredWork: 'Karya pilihan',
      featuredWorkDesc: 'Kami menciptakan desain inovatif dan bertujuan yang tidak hanya menarik perhatian tetapi juga mendorong hasil yang bermakna.',
    },

    // About
    about: {
      title: 'Desain Berorientasi Hasil',
      subtitle: 'Fokus pada aplikasi mobile dan web platform, saya menghadirkan inovasi, performa, dan desain yang berpusat pada pengguna di setiap proyek.',
      partOf: 'Bagian dari',
      digitalEcosystem: 'Ekosistem Digital',
      description: 'Alvin Ahmad berdedikasi untuk membangun solusi digital berdampak tinggi yang memberdayakan pengguna dan bisnis di seluruh dunia.',
      description2: 'Fokus pada aplikasi mobile dan web platform, saya menghadirkan inovasi, performa, dan desain yang berpusat pada pengguna di setiap proyek.',
      viewMyWork: 'LIHAT KARYA SAYA',
      technologies: 'Teknologi',
      cleanCode: 'Kode bersih adalah passion saya',
      yearsExp: 'Tahun Pengalaman',
      projectsDone: 'Proyek Selesai',
      clientsSatisfied: 'Klien Puas',
      contactMe: 'HUBUNGI SAYA',
      resultDriven: 'Berorientasi Hasil',
      designDriver: 'Desain adalah penggerak kuat performa pemasaran. Beberapa langsung mendarat dengan landing page yang kikuk, yang lain menghabiskan berminggu-minggu memperhatikan detail. Kami menemukan keseimbangan menciptakan budaya desain yang tajam, efisien, dan dibangun untuk berperforma.',
      effectiveDesign: 'Desain yang efektif menyelesaikan masalah nyata baik itu meningkatkan nilai persepsi, meningkatkan konversi, memperjelas pesan merek, atau beradaptasi dengan pasar baru. Untuk mencapai ini, bisnis membutuhkan desainer berpengalaman yang memahami visi mereka dan lanskap yang terus berkembang.',
      mission: 'adalah pengembang perangkat lunak dengan misi yang jelas: membangun produk digital yang menggabungkan kode bersih, performa, dan pengalaman pengguna yang luar biasa. Terlalu sering, aplikasi mengorbankan kemudahan penggunaan untuk fitur atau sebaliknya.',
      handlingApps: 'menangani web apps produksi',
      raisedRevenue: 'Meningkatkan pendapatan dari proyek-proyek',
      freelanceAvailable: 'Tersedia untuk proyek freelance dan kolaborasi. Mari bangun sesuatu yang luar biasa bersama.',
      passionBio: 'Saya adalah pengembang perangkat lunak yang berdedikasi dalam membangun aplikasi mobile dan web berkualitas tinggi. Dengan keahlian dalam React, React Native, dan teknologi web modern, saya menghadirkan solusi yang berperforma baik dan ramah pengguna.',
    },

    // Work
    work: {
      title: 'Karya Pilihan',
      subtitle: 'Koleksi proyek yang pernah saya kerjakan',
      loading: 'Memuat proyek...',
      error: 'Gagal memuat proyek',
      retry: 'Coba Lagi',
      gridView: 'Tampilan Grid',
      listView: 'Tampilan Daftar',
      viewProject: 'Lihat Proyek',
      viewDemo: 'Lihat Demo',
      viewCode: 'Lihat Kode',
    },

    // Project
    project: {
      notFound: 'Proyek tidak ditemukan',
      backToWork: 'Kembali ke Karya',
      back: 'Kembali',
    },

    // Contact
    contact: {
      title: 'Mari Bekerja Sama',
      subtitle: 'Punya proyek dalam rencana? Mari diskusi bagaimana saya dapat membantu mewujudkan ide Anda.',
      name: 'Nama Anda',
      email: 'Email Anda',
      phone: 'Nomor Telepon',
      company: 'Perusahaan',
      website: 'Website (opsional)',
      sendMessage: 'Kirim Pesan',
      sending: 'Mengirim...',
      successMessage: 'Pesan berhasil dikirim!',
      errorMessage: 'Gagal mengirim pesan. Silakan coba lagi.',
      faqTitle: 'Pertanyaan yang Sering Diajukan',
      testimonialsTitle: 'Apa Kata Klien',
      bookCall: 'JADWALKAN PANGGILAN',
      bookDiscoveryCall: 'Jadwalkan Konsultasi Gratis',
      formTitle: 'Mari Diskusi Proyek Anda',
      availableSlots: 'Slot waktu tersedia saat ini',
      contactSales: 'HUBUNGI SALES',
      nameLabel: 'Nama lengkap',
      emailLabel: 'Email *',
      phoneLabel: 'Nomor telepon *',
      companyLabel: 'Perusahaan *',
      websiteLabel: 'Website *',
      loginPricing: 'Masuk, Lihat Harga & Brief',
      trustedBy: 'DIPERCAYA OLEH KLIEN DI SELURUH DUNIA',
      heading: 'Mari Bangun Produk Digital Anda',
      headingDesc: 'Saya adalah pengembang perangkat lunak yang mengkhususkan diri dalam aplikasi mobile dan web. Dari konsep hingga deployment, saya menghadirkan solusi yang cepat, skalabel, dan elegan.',
      startups: 'Startup',
      smes: 'UKM',
      enterprises: 'Perusahaan Besar',
      agencies: 'Agensi',
      availableForProjects: 'Tersedia untuk Proyek Baru',
      trustedByClients: 'Dipercaya oleh',
      satisfiedClients: 'klien puas',
      fullName: 'Nama lengkap',
      emailRequired: 'Email *',
      phoneRequired: 'Nomor telepon *',
      companyRequired: 'Perusahaan *',
      websiteRequired: 'Website *',
      successMsg: 'Pesan berhasil dikirim! Saya akan segera menghubungi Anda.',
      errorMsg: 'Gagal mengirim pesan. Silakan coba lagi atau hubungi saya melalui email.',
      faq1Question: 'Jenis proyek apa yang Anda tangani?',
      faq1Answer: 'Saya mengkhususkan diri dalam pengembangan aplikasi mobile (React Native) dan web (React/Next.js), dari MVP hingga aplikasi produksi skala penuh.',
      faq2Question: 'Berapa lama timeline proyek biasa Anda?',
      faq2Answer: 'Tergantung kompleksitasnya. Landing page membutuhkan 3-5 hari, company profile 7-14 hari, dan web/mobile app penuh 20-30 hari.',
      faq3Question: 'Apakah Anda bekerja dengan klien internasional?',
      faq3Answer: 'Tentu! Saya bekerja dengan klien dari seluruh dunia. Saya fleksibel dengan zona waktu dan berkomunikasi terutama dalam bahasa Inggris dan Indonesia.',
      faq4Question: 'Teknologi apa yang Anda gunakan?',
      faq4Answer: 'Saya utamanya menggunakan React/Next.js untuk frontend, Node.js/Supabase untuk backend, dan React Native untuk aplikasi mobile. Saya fleksibel sesuai kebutuhan proyek.',
      faq5Question: 'Apakah Anda menyediakan dukungan berkelanjutan setelah peluncuran?',
      faq5Answer: 'Ya, saya menawarkan paket pemeliharaan dan dapat memberikan dukungan berkelanjutan untuk perbaikan bug, pembaruan, dan fitur baru.',
    },

    // Profile
    profile: {
      hireMe: 'Hubungi Saya',
      resumeDesc: 'Pratinjau resume saya secara online atau unduh salinan untuk referensi Anda.',
      getResume: 'Unduh Resume',
      previewResume: 'Pratinjau Resume',
    },

    // Seller
    seller: {
      welcome: 'Selamat Datang di',
      galaxyStore: 'Galaxy Store',
      developer: 'Portal Pengembang',
      subtitle: 'Aplikasi Android premium untuk perangkat Samsung Galaxy',
      visitStore: 'Kunjungi Galaxy Store',
      documentation: 'Dokumentasi',
      statsTitle: 'Statistik Aplikasi',
      statsSubtitle: 'Pantau kinerja seluruh aplikasi yang telah diterbitkan',
      totalApps: 'Total Aplikasi Diterbitkan',
      avgRating: 'Rating Rata-rata',
      totalDownloads: 'Total Unduhan',
      policiesTitle: 'Kebijakan Pengembang',
      policiesSubtitle: 'Panduan dan kebijakan untuk pengajuan aplikasi',
      termsOfService: 'Ketentuan Layanan',
      tosDesc: 'Aturan dan pedoman penggunaan platform pengembang kami',
      readTerms: 'Baca Ketentuan',
      privacyPolicy: 'Kebijakan Privasi',
      privacyDesc: 'Bagaimana kami mengumpulkan, menggunakan, dan melindungi data Anda',
      viewPolicy: 'Lihat Kebijakan',
      contactTitle: 'Kontak & Dukungan',
      contactSubtitle: 'Hubungi tim dukungan pengembang kami',
      email: 'Email',
      sendEmail: 'Kirim Email',
      whatsapp: 'WhatsApp',
      message: 'Pesan',
      responseTime: 'Respons dalam 24 jam',
      freeConsultation: 'Konsultasi Awal Gratis',
    },

    // Seller Help
    sellerHelp: {
      title: 'Ada yang Bisa Saya Bantu?',
      subtitle: 'Temukan jawaban seputar layanan pengembangan aplikasi saya, dapatkan penawaran proyek, dan pelajari proses pengembangan saya',
      searchPlaceholder: 'Cari jawaban...',
      popular: 'Populer',
      browseByCategory: 'Telusuri Berdasarkan Kategori',
      categorySubtitle: 'Pilih topik untuk menemukan jawaban yang relevan dengan cepat',
      allTopics: 'Semua Topik',
      appDevelopment: 'Pengembangan Aplikasi',
      businessPayment: 'Bisnis & Pembayaran',
      supportMaintenance: 'Dukungan & Pemeliharaan',
      allQuestions: 'Semua Pertanyaan',
      resultsFound: 'hasil ditemukan',
      helpful: 'Membantu',
      needMoreHelp: 'Butuh Bantuan Lebih?',
      stillNeedHelp: 'Masih Butuh Bantuan?',
      supportSubtitle: 'Mari berdiskusi tentang proyek Anda dan bagaimana saya dapat membantu mewujudkan ide Anda',
      directContact: 'Kontak Langsung',
      contactDesc: 'Dapatkan konsultasi personal untuk proyek Anda',
      projectConsultation: 'Konsultasi Proyek',
      consultationDesc: 'Kirim pesan untuk mendiskusikan kebutuhan Anda',
      sendEmail: 'Kirim Email',
      message: 'Pesan',
      rateExperience: 'Bagaimana pengalaman Anda dengan layanan saya?',
      feedbackSubtitle: 'Umpan balik Anda membantu saya meningkatkan kualitas layanan',
      noResults: 'Tidak Ada Hasil Ditemukan',
      noResultsDesc: 'Coba sesuaikan kata kunci atau telusuri kategori berbeda',
      resetFilters: 'Atur Ulang Filter',
      startProject: 'Mulai Proyek',
      startProjectDesc: 'Dapatkan penawaran untuk pengembangan aplikasi sesuai kebutuhan Anda',
      viewPortfolio: 'Lihat Portofolio',
      viewPortfolioDesc: 'Lihat karya dan proyek saya sebelumnya',
      technicalDocs: 'Dokumentasi Teknis',
      technicalDocsDesc: 'Akses panduan dan sumber daya pengembangan',
      devSupport: 'Dukungan Pengembang',
      thankFeedback: 'Terima kasih atas umpan balik Anda',
      thankRating: 'Terima kasih telah memberikan rating',
      stars: 'bintang',
      results: 'hasil',
      result: 'hasil',
      found: 'ditemukan',
      responseWithin24: 'Respons dalam 24 jam',
      freeConsultation: 'Konsultasi Awal Gratis',
    },

    // Pricing
    pricing: {
      eyebrow: 'Harga',
      title: 'Harga sederhana dan transparan untuk hasil nyata.',
      subtitle: 'Pilih paket dan metode pembayaran — lunas, DP 50%, atau per milestone. Setiap proyek berjalan melalui dashboard Anda dengan invoice, AI project manager, dan deliverable akhir.',
      payInFull: 'Bayar Lunas',
      payInFullDesc: 'Satu pembayaran, selesaikan seluruh proyek di muka.',
      dp50: 'DP 50%',
      dp50Desc: 'Bayar setengah untuk memulai, sisanya saat selesai.',
      milestone: 'Per Milestone',
      milestoneDesc: 'Bagi menjadi milestone dari brief Anda; bayar seiring berjalan.',
      all: 'Semua',
      mostPopular: 'Paling Populer',
      startProject: 'Mulai Proyek',
      contactUs: 'Hubungi Kami',
      perProject: '/ proyek',
      custom: 'Kustom',
      noPackages: 'Belum Ada Paket',
      noPackagesDesc: 'Tambahkan paket layanan di admin dashboard untuk menampilkannya di sini.',
      startYourProject: 'Mulai Proyek Anda',
      projectTotal: 'Total Proyek',
      chooseHowToPay: 'Pilih Metode Pembayaran',
      setFromBrief: 'Tentukan dari Brief',
      settingUp: 'Menyiapkan...',
      continueToDashboard: 'Lanjutkan ke Dashboard',
      signInWithGoogle: 'Masuk dengan Google',
      nextStep: 'Selanjutnya: ceritakan tentang proyek Anda, lalu bayar secara aman melalui Doku. Anda dapat melacak semuanya di dashboard Anda.',
      nowThen: 'sekarang, lalu',
    },

    // Common
    common: {
      loading: 'Memuat...',
      error: 'Kesalahan',
      retry: 'Coba Lagi',
      back: 'Kembali',
      close: 'Tutup',
      save: 'Simpan',
      cancel: 'Batal',
      confirm: 'Konfirmasi',
      delete: 'Hapus',
      edit: 'Edit',
      add: 'Tambah',
      search: 'Cari',
      filter: 'Filter',
      sort: 'Urutkan',
      next: 'Selanjutnya',
      previous: 'Sebelumnya',
      pageNotFound: 'Halaman Tidak Ditemukan',
      backToHome: 'Kembali ke Beranda',
    }
  }
};

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('portfolio-language');
    return saved || 'EN';
  });

  useEffect(() => {
    localStorage.setItem('portfolio-language', language);
    document.documentElement.lang = language.toLowerCase();
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'EN' ? 'ID' : 'EN');
  };

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      value = value?.[k];
    }
    
    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
